import 'angular:locale/data:it';
import 'zone.js';(globalThis.$localize ??= {}).locale = "it";
